/**
 * Scroll detection using Intersection Observer
 * Adds 'is-scrolled' class to body when page is scrolled
 * 
 * @author assistant
 */

import debounce from 'debounce'

// Scroll direction handler

let lastScrollTop = document.documentElement.scrollTop;
let lastScrollDistance = 0;
let isScrolledDown = false;
let isScrolledUp = false;


/**
 * Add or remove utility-classed to the body element based on scrolling
 */
const handleScroll = () => {

    const currentScrollTop = document.documentElement.scrollTop;

    if ( currentScrollTop === 0 ) {
        document.body.classList.add( 'is-scrolled-top' );
    } else {
        document.body.classList.remove( 'is-scrolled-top' );
    }

    if (currentScrollTop > lastScrollTop) {

        isScrolledDown = true;
        isScrolledUp = false;
        
        document.body.classList.add('is-scrolled-down');
        document.body.classList.remove('is-scrolled-up');

    } else if (currentScrollTop < lastScrollTop) {
        
        isScrolledDown = false;
        isScrolledUp = true;
        
        document.body.classList.add('is-scrolled-up');
        document.body.classList.remove('is-scrolled-down');

    }

    lastScrollDistance = Math.abs( currentScrollTop - lastScrollTop );
    lastScrollTop = currentScrollTop;
};

// Sticky header handler



const init = () => {

    // Create sentinel elements

    const topSentinel = document.createElement('div');
    topSentinel.classList.add('scroll-observer--sentinel', 'scroll-observer--sentinel-top');
    
    const bottomSentinel = document.createElement('div');
    bottomSentinel.classList.add('scroll-observer--sentinel', 'scroll-observer--sentinel-bottom');

    // Observer options

    const options = {
        root: null, // Viewport
        threshold: 0
    };

    // Create the observer for is-scrolled class

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.target.classList.contains('scroll-observer--sentinel-top')) {
                document.body.classList.toggle('is-scrolled', !entry.isIntersecting);
            }
        });
    }, options);

    // Start observing both sentinels

    observer.observe(topSentinel);
    observer.observe(bottomSentinel);

    // Insert sentinels

    document.body.prepend(topSentinel);
    document.body.appendChild(bottomSentinel);

    // Add scroll event listener

    window.addEventListener( 'scroll', debounce( handleScroll, 50 ), { passive: true } )

    // Initial update

    handleScroll();

};

export { init };

